import React, { Component } from 'react'
import { Redirect} from "react-router-dom";
import { useMutation, } from '@apollo/client';

import { SUBMIT_ABSTRACT, SUBMIT_PAPER, USER_PROFILE } from '../../queries';


const SubmitAbstractContainer = ({ teamId, paperFilename, paperFileUrl }) => {
    const [ submit, { data, loading, error }] = useMutation(SUBMIT_PAPER);

    return (
        <RegisterCompetitionForm
            teamId={teamId}
            paperFilename={paperFilename}
            paperFileUrl={paperFileUrl}
            submit={submit}
            success={data}
            loading={loading}
            error={error}/>
    );
}

class RegisterCompetitionForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paperFile: null
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
    }

    handleFileChange(event) {
        this.setState({
            paperFile: event.target.files[0]
        });
        
    }

    async handleSubmit(event) {
        event.preventDefault();

        if (!this.state.paperFile || this.state.paperFile.size > 5000000){
            alert("Masukkan file Paper dan pastikan dibawah 5 MB");
            return 0;
        }

        const o = {
            variables: {
                teamId: this.props.teamId,
                paperFile: this.state.paperFile,
            },
            refetchQueries: [{ query: USER_PROFILE}]
        };

        

        try {
          await this.props.submit(o);
          alert("Upload Paper Berhasil!")
        }
        catch (e) {
        }
    }

    render() {
        console.log(this.props);
        return (
            <div className="container text-center">
                  <hr></hr>
                  <h4 style={{fontWeight:'bold'}}>Submit Paper</h4>
                  {this.props.paperFilename ?
                    <h4>Submitted {this.props.paperFilename}</h4> :
                    <></>}
                    {this.props.paperFileUrl ?
                    <a href={this.props.paperFileUrl}><u>Click to check your Paper</u></a> :
                    <></>}
                  <form onSubmit={this.handleSubmit}>
                          <h5 style={{
                              fontSize: "10px",
                              padding : 0,
                              float: 'right'
                          }}>Format: pdf, Max Size: 5 MB</h5>
                        <input
                            name="upload"
                            type="file"
                            accept=".pdf,application/pdf"
                            onChange={this.handleFileChange}
                            style={{width:'100%'}}
                        />
                    {this.props.error ? <p className="text-danger text-center">{this.props.error.message}</p> : <></>}
                    <button disabled={this.props.loading || !this.state.paperFile} className="btn btn-primary btn-block mt-3 mb-3 shadow-sm" type="submit">
                        {this.props.paperFilename ?
                            'Resubmit' :
                            'Submit'}
                    </button>
                  </form>
            </div>
        );
    }
}

export default SubmitAbstractContainer;
